import { useCallback } from 'react';
import {
  DateRangePresetName,
  getUiDateTimeRangeFromPreset,
  StandardDateRangePresetNames,
} from 'src/utils/dateTimeUtils';
import { DateTimeRange } from 'src/WebApiController';

import { SponsoredListingsSectionType } from './SponsoredListings.types';

export const useSponsoredListingUrl = () => {
  // Helper functions for URL serialization
  const getInitialStateFromUrl = useCallback(() => {
    const params = new URLSearchParams(window.location.search);

    const sectionTypeParam = params.get('sectionType');
    const initialSectionType =
      sectionTypeParam &&
      Object.values(SponsoredListingsSectionType).includes(
        sectionTypeParam as SponsoredListingsSectionType
      )
        ? (sectionTypeParam as SponsoredListingsSectionType)
        : SponsoredListingsSectionType.TimelineView;  // Default section type

    const dateRangeStartParam = params.get('dateRangeStart');
    const dateRangeEndParam = params.get('dateRangeEnd');
    const initialDateRangeFilter = dateRangeStartParam
      ? ({
          start: dateRangeStartParam,
          end: dateRangeEndParam,
        } as DateTimeRange)
      : (getUiDateTimeRangeFromPreset(
          DateRangePresetName.Last30Days,
          StandardDateRangePresetNames
        ) ?? null);

    return { initialSectionType, initialDateRangeFilter };
  }, []);

  const updateUrlParams = useCallback(
    (
      sectionType: SponsoredListingsSectionType,
      dateRangeFilter: DateTimeRange | null
    ) => {
      const params = new URLSearchParams(window.location.search);

      params.set('sectionType', sectionType);

      if (dateRangeFilter) {
        params.set('dateRangeStart', dateRangeFilter.start || '');
        if (dateRangeFilter.end) {
          params.set('dateRangeEnd', dateRangeFilter.end);
        } else {
          params.delete('dateRangeEnd');
        }
      } else {
        params.delete('dateRangeStart');
        params.delete('dateRangeEnd');
      }

      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
    },
    []
  );

  const { initialSectionType, initialDateRangeFilter } =
    getInitialStateFromUrl();

  return { initialSectionType, initialDateRangeFilter, updateUrlParams };
};
